import { apiRequest } from './api';

export const locationApi = {
  getAllCountries: () => apiRequest('/location/countries'),
  getCitiesByCountryId: (id) => apiRequest(`/location/countries/${id}/cities`),
};
